export default {
	subscriptions: {
		activeSubscription: 'Active subscription: ',
		features: 'Features',
		description: {
			basic: 'Basic Version',
			full: 'Full Version',
		},
		property_manager: 'Property Manager',
		person_update_requests: 'Personal Data Update',
		user_normal: 'End Customer',
		notification_welcome: 'Registration Notification',
		notification_lost_password: 'Password Update',
		notification_damage_report: 'Damage Report',
		notification_message: 'News',
		notification_note: 'Notes Notification',
		notification_meter: 'Meter Notification',
		notification_document: 'Document Notification',
		notification_handover: 'Handover Notification',
		notification_person_update: 'Personal Data Update Notification',
		notification_tos: 'TOS Notification',
		notification_ticket_history: 'Tickets Notification',
		notification_consumption: 'Consumption Notification',
		notification_review_document: 'Document Review Notification',
		notification_report: 'Report Notification',
		external_track_lean: 'Track Lean',
		external_inbound_mail: 'Incomming Emails',
	},
}
